import { Injectable } from "@angular/core";
import { StateAcronym } from "src/app/ui/models/domains/pbm/state/state-acronym";
import { AbstractParser } from "../../parser";

@Injectable()
export class StateAcronymParser extends AbstractParser<StateAcronym[]> {
  parse(payload: any): StateAcronym[] {
    const stateAcronymModel: Array<StateAcronym> = [];
    if (payload) {
      payload.forEach((uf) => {
        const state = new StateAcronym(uf.Value);
        stateAcronymModel.push(state);
      });
    }
    return stateAcronymModel;
  }
}
